import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";

var _types$REQUEST_SETTIN;

import * as types from "@/store/constants/types";
export default (_types$REQUEST_SETTIN = {}, _defineProperty(_types$REQUEST_SETTIN, types.REQUEST_SETTING_DATA, function (state, payload) {
  // console.log(payload);
  state.settingData = payload;
}), _defineProperty(_types$REQUEST_SETTIN, types.UPDATE_MORNING_NOOTICE_STATUS, function (state, payload) {
  state.isShowMoringNotification = payload;
}), _defineProperty(_types$REQUEST_SETTIN, types.UPDATE_EVNING_NOOTICE_STATUS, function (state, payload) {
  state.isShowEveningNotification = payload;
}), _defineProperty(_types$REQUEST_SETTIN, types.UPDATE_LAUNCH_CONFIG, function (state, payload) {
  state.launchConfig = payload;
}), _defineProperty(_types$REQUEST_SETTIN, types.UPDATE_OFFER_ID, function (state, payload) {
  state.offer_id = payload;
}), _types$REQUEST_SETTIN);